import React, { FC, useEffect } from 'react';
import OnboardingCustomApp, {
  OnboardingAppTypes,
  useOnboardingServices,
} from '~/src/components/CustomApp/OnboardingCustomApp';
import Guest from '~/src/screens/Guest';
import { VIEW_EVENTS } from '~/src/services/analytics/contants';
import { AppComponentType } from '../_app';

const GuestPage: FC<OnboardingAppTypes> & AppComponentType = () => {
  const { Analytics, setMainResourcesLoaded } = useOnboardingServices();

  useEffect(() => {
    Analytics.sendEvent(VIEW_EVENTS.mainMenu);
    setMainResourcesLoaded(true);
  }, []);

  return <Guest />;
};

GuestPage.render = (props) => <OnboardingCustomApp {...props} />;

export default GuestPage;
